import { Injectable } from "@angular/core";
import { PlessJsonResponderSub } from "src/app/commons/kymw00/pless-json-responder-sub.service";
import { KYMW7403Model } from "../kymw7403.model";
import { PlessRequest } from "src/app/shared/vo/pless-request.model";
import { ConfirmData } from "../vo/confirm-data.model";

// レスポンス構造
export type OutputRememberGoodsDiffResponce = {
  FileName: string
}

/**
 * 忘れず注文商品差分出力
 * 
 */
@Injectable()
export class OutputRememberGoodsDiffService extends PlessJsonResponderSub<OutputRememberGoodsDiffResponce> {
  successFunc: Function;
  model: KYMW7403Model;
  /** 出力対象データ */
  confirm: ConfirmData;
  /** 比較対象データ */
  comparing: ConfirmData;

  /**
   * bodyにセットする値を返す
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputRememberGoodsDiffService
   */
  getBody() {
    return new PlessRequest({
      parameter: {
        ConfirmDate: this.confirm.confirmDate,
        ConfirmUserId: this.confirm.confirmUserId,
        CatalogId:  this.model.catalogIdDiff,
        ComparingDate:  this.comparing.confirmDate,
        ComparingUserId:  this.comparing.confirmUserId,
        ComparingCatalogId: this.model.comparingCatalogId,
      }
    })
  }

  /**
   * API呼び出し
   * @param model 
   * @param confirm   出力対象データ
   * @param comparing 比較対象データ
   * @param successFunc
   * @memberof OutputRememberGoodsDiffService 
   */
  execute(model: KYMW7403Model, confirm: ConfirmData, comparing: ConfirmData, successFunc: Function = null){
    this.model = model;
    this.confirm = confirm;
    this.comparing = comparing;
    this.successFunc = successFunc;
    this.send('outputRememberGoodsDiff', this.getBody());
  }

  /**
   * API成功後処理
   * @param data 
   * @memberof OutputRememberGoodsDiffService
   */
  success(data: OutputRememberGoodsDiffResponce): void {
    if ( this.successFunc !== null ) this.successFunc(data);
  }
}